import { render, staticRenderFns } from "./TimeFrameComponent.vue?vue&type=template&id=04179efc&scoped=true&"
import script from "./TimeFrameComponent.vue?vue&type=script&lang=js&"
export * from "./TimeFrameComponent.vue?vue&type=script&lang=js&"
import style0 from "./TimeFrameComponent.vue?vue&type=style&index=0&id=04179efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04179efc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VRow})
